"use strict";
const negateExpression = require('./negateExpression');
const { ENDS_WITH, NOT_ENDS_WITH } = require('../definitions/operators');
module.exports = negateExpression(ENDS_WITH, NOT_ENDS_WITH);
//# sourceMappingURL=notEndsWithExpression.js.map